module.exports = __webpack_public_path__ + "img/reward_screen_shot.8db1e30c.png";